// extracted by mini-css-extract-plugin
export default {"editButton":"hrStop_editButton__Ypyu-","TableBody":"hrStop_TableBody__fkAnD","StopButton":"hrStop_StopButton__u+OLA"};